<script>
import baseEdit from './../../components/base/baseEdit.vue'
export default {
    extends: baseEdit,
    components: {},
    data() {
        return {
            mname: "patrolType",
            key: 'id',
            url: {
                get: '/admin/system/patrolType',
                add: '/admin/system/patrolType',
                edit: '/admin/system/patrolType',
            },
            items: [
                { label: "基本信息", desc: "表单的基本信息", type: "header" },
                {
                    label: "巡检类别名称",
                    name: "typeName",
                    value: "",
                    type: "input",
                    width: '400px',
                    rules: [{ required: true, trigger: "blur" }],
                },
                {
                    label: "巡检项",
                    name: "patrolSceneIds",
                    value: "",
                    type: "multiple",
                    dropList: [],
                    width: "400px",
                    onChange: this.onCouponAlis,
                },
                // {
                //   label: "场景地址",
                //   name: "address",
                //   value: "",
                //   type: "input",
                //   width:'400px',
                //   rules: [{ required: true, trigger: "blur" }],
                // },
                // { label: "备注", name: "remark", value: "", type: "textarea" },
            ],
            forms: {},
        };
    },
    created() {
        this.loadworkData()
    },
    methods: {
        initData() {
            let id = this.kv;
            $utils.api.load(`/admin/system/patrolType/${id}`, {}).then((res) => {
                if (res && res.data) {
                    this.forms = res.data;
                    let patrolSceneIds = res.data.patrolSceneId.split(",");
                    this.forms.patrolSceneIds = patrolSceneIds.map(Number);
                }
            })
        },
        //巡检项下拉框
        async loadworkData() {
            // 通过pk查询字典数据
            let q = {};
            let res = await $utils.api.load("/admin/system/scene/selectList", q, 'get')
            if (res && res.rows) {
                let ll = res.rows;
                let dropList = [];
                for (let index = 0; index < ll.length; index++) {
                    const element = ll[index];
                    let xx = {};
                    xx.value = element.id;
                    xx.name = element.sceneName;
                    dropList.push(xx);
                }
                for (let index = 0; index < this.items.length; index++) {
                    const element = this.items[index];
                    if (element && element.name == "patrolSceneIds") {
                        this.items[index]["dropList"] = dropList;
                    }
                }
            }
        },
        onCouponAlis(val) {
            console.log(val);
            let ass = val.join(",");
            this.forms.patrolSceneId = ass;
        },
    },
};
</script>
